<template>
  <div v-if="!chatStarted && !hasHistory" class="start-block">
    <div class="tf-toaster text-center" v-if="!visibilityOfPrechatForm && !error">
      <h2>{{ $t('needHelp') }}</h2>
      <p>{{ $t('letUsKnow') }}</p>
      <div class="toaster_button_groups">
        <button class="start-block__button cancel" @click="cancelChat();cancelToaster() ">{{ $t('noThanks') }}</button>
        <button class="start-block__button" @click="proccedToPrechat">{{ $t('startChat') }}</button>
      </div>
    </div>
    <PreChatForm v-if="visibilityOfPrechatForm"
      :prechatInputs="prechatList"
      :privacyDisclaimerMessage="privacyDisclaimer"
      :userDetails="userDetails"
      @submit="startInitiateChat($event)"
    />
  </div>
</template>

<script>
import PreChatForm from '@/components/forms/PreChatForm.vue'
import { mapState } from 'pinia'
import { useWidgetStore } from '@/store'

export default {
  name: 'PreChatFormContainer',
  components: {
    PreChatForm
  },
  props: {
    visibilityOfPrechatForm: {
      type: Boolean,
      default: false
    },
    hasHistory: {
      type: String,
      default: ' '
    },
    prechatList: {
      type: Array,
      default: () => []
    },
    privacyDisclaimer: {
      type: String,
      default: ' '
    },
    userDetails: {
      type: Object,
      default: () => ({})
    },
     error: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState(useWidgetStore, ['chatStarted', 'brandingColor'])
  },
  emits: ['cancelChat', 'proccedToPrechat', 'startChat', 'startInitiateChat', 'cancelToaster'],
  methods: {
    cancelChat () {
      this.$emit('cancelChat')
    },
    cancelToaster () {
      this.$emit('cancelToaster')
    },
    proccedToPrechat () {
      this.$emit('proccedToPrechat')
    },
    startChat () {
      this.$emit('startChat')
    },
    startInitiateChat (event) {
      this.$emit('startInitiateChat', event)
    }
  }
}
</script>

<style scoped>
.start-block {
  display: flex;
  flex-direction: column;
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #222222;
    line-height: 20px;
    margin-bottom: 0;
    margin-top: 9px;
  }
  p {
    font-size: 12px;
    color: #767676;
    margin-bottom: 8px;
    margin-top: 8px;
    line-height: 1rem;
  }
  input {
    height: 40px;
    width: 100%;
    border: 1px solid #C9C8C8;
    border-radius: 5px;
    outline: none;
    padding: 10px 12px;
    margin: 8px 0;
    font-size: 14px;
    color: #222222;
  }
  button {
    cursor: pointer;
    border: none;
    padding: 6px 16px;
    height: 32px;
    background-color:  v-bind('brandingColor');
    color: #fff;
    font-size: 11.2px;
    font-weight: 700;
    border-radius: 3px;
    margin-left: auto;
    margin-top: 19.2px;
  }
  button:disabled {
    background-color: #DCDCDC;
    color: #A2A2A2;
  }
  .cancel {
    background-color: #fff;
    color: #0052ff;
    border: 1px solid #ccc;
    margin-right: 12.8px;
  }
  .cancel:hover {
    background-color: #fff !important;
  }
}
</style>
